import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {configTagsEdit_template} from "../components/templates/configTagsEdit_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class config_tags_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected editForm: configTagsEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){

        return "config_tags_edit";
    }

    buildContent() : Array<Element>{

        this.editForm = new configTagsEdit_template("editForm", this.viewModel, this);
        return [this.editForm.build()];
    }

    public fillPage() : void{

        this.editForm.buildDatePickerCalendar();
        this.getTag();
    }

    public cancelForm() {
        this.cancel();
    }

    protected cancel(){

        this.releaseLock();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect('/brand/' + idBrand + "/categorization/tags/");
    }

    protected getTag(){

        this.loadingIn(this.editForm.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idCategory = this.getVnAppZone().getApp().params.idTag;

        let usrReq_url: string = '/api/brand/' + idBrand + "/tags/get/"+idCategory;

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.editForm.getViewModelForRequest();

        usrReq_params.push(["data", ko.toJSON({lockItem: true})] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.setForm(responseParsed);
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    protected setForm(responseParsed: any){

        this.editForm.setTag(responseParsed.data)
    }

    protected save(){

        this.loadingIn(this.editForm.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/tags/save";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.releaseLock();
                    page.redirect('/brand/' + idBrand + "/categorization/tags/");

                });
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    protected releaseLock() {

        // request a lock release
        let idTag = this.getVnAppZone().getApp().params.idTag;

        let usrReq_url: string = '/api/brand/tags/release/'+idTag;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    public filterDropdownOnChange() {

        this.getImageData();
    }

    //image picker functions
    protected getImageData() {

        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.editForm.imagePicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/get/';
        let formReq_params: Array<Array<string>> = [];

        //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(this.editForm.imagePicker.getViewModelForRequest())]);

        this.imageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.editForm.imagePicker.hideLoading();
                if(obj.editForm.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }
                //TODO after save
            })
        }
    }

    protected updateImagePickerForm(responseParsed) {
        let selectedImages = this.editForm.imagePicker.getSelectedImages();

        if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
            for (let image of responseParsed.paginatedImages.data) {
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.editForm.imagePicker.setImagesPagination(responseParsed.paginatedImages);
            this.editForm.imagePicker.setImageResults(responseParsed.paginatedImages.data);
        }
    }

    protected bytesToSize(bytes) {
        var sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    }

    protected insertImage(image, target) {

        let imgTag = this.buildImageTag(image, false);

        if(target == "tagImage") {
            this.editForm.setTagImage(image);
        }

    }

    protected buildImageTag(image, addCaption): string {
        let imgTag = '<img ';
        imgTag += 'src="' + image.url + '" ';
        if (image.altText != null) {
            imgTag += 'alt="' + image.altText + '" ';
        } else {
            imgTag += 'alt="" ';
        }
        imgTag += ' width=' + image.width + ' height=' + image.height + ' />';

        //add caption
        if (addCaption && image.caption != null && image.caption.trim() != "") {
            imgTag = '[caption]' + imgTag + ' ' + image.caption + '[/caption]';
        }

        return imgTag;
    }

}


// WEBPACK FOOTER //
// ./js/modules/config_tags_edit.ts